export default function publicProjects(state, action) {
  switch(action.type) {
    case 'RECEIVED_PUBLIC_PROJECT_LIST':
      return action.projectList;
    default:
      return state;
  }
}
